import React, { useState } from "react";
import { useContext, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { Button, Container } from "react-bootstrap";
import "./memberData.css";
import FormFrame from "../../components/form/form";
import "./../../components/button/button.css";
import "./../../components/background/background.css";
import Image from "../../assets/background.png";
import Header from "../../components/header/header";
import { AuthContext } from "../../App";
import { getUser, putClinic, deleteUser } from "../../utils/api";
import Swal from "sweetalert2";
import { authentication } from "../../utils/config";
import ImageBack from "../../assets/back.png";
import mapping from "../../utils/areaMapping";

const MemberData = () => {
  const navigate = useNavigate();
  const lineProfile = useContext(AuthContext);

  // state hook
  const [userData, setUserData] = useState({
    code: "",
    email: "",
    clinicName: "",
    hostName: "",
    areaId: "",
    address: "",
    phone: "",
    id: "",
  });

  useEffect(() => {
    let flag = true;
    //渲染前判斷是否具有line身分
    const auth = async () => {
      const response = await authentication(lineProfile.userId);
      if (response.error || response.data === "no lineId")
        return navigate("/error");
      else if (
        response.data === "no user" ||
        response.data === "no vertification"
      )
        return navigate("/email");
      else if (response.data === "vertified") return navigate("/register");
      flag = false;
    };

    //查找使用者資訊
    const getUserFunction = async () => {
      if (flag) return;
      const response = await getUser(lineProfile);
      if (response.error) {
        await Swal.fire({
          title: "系統錯誤",
          text: JSON.stringify(response.data),
          icon: "error",
        });
      } else if (response.data === "not found the user") {
        await Swal.fire({
          title: "帳號不存在",
          text: "請註冊帳號",
          icon: "error",
        });
      } else {
        const data = response.data;
        setUserData((prevData) => {
          const updatedData = {
            ...prevData,
            ["code"]: data.clinic.code,
            ["email"]: data.clinic.email,
            ["clinicName"]: data.clinic.name,
            ["hostName"]: data.clinic.hostName,
            ["address"]: data.clinic.address,
            ["phone"]: data.clinic.phone,
            ["id"]: data.clinic.id,
            ["areaId"]: data.clinic.areaId,
          };
          return updatedData;
        });
      }
    };

    const combine = async () => {
      await auth();
      await getUserFunction();
    };
    combine();
  }, []);

  const formData = [
    {
      title: "診所會員編號",
      value: userData.code,
      required: true,
      disabled: true,
      name: "code",
    },
    {
      title: "電子郵件",
      value: userData.email,
      required: true,
      disabled: true,
      name: "email",
    },
    {
      title: "診所名稱(請填寫完整診所名稱)",
      value: userData.clinicName,
      required: true,
      disabled: false,
      name: "clinicName",
    },
    {
      title: "聯絡人",
      value: userData.hostName,
      required: true,
      disabled: false,
      name: "hostName",
    },
    {
      title: "聯絡電話",
      value: userData.phone,
      required: true,
      disabled: false,
      name: "phone",
    },
    {
      title: "診所地址",
      value: `${mapping[userData.areaId]} ${userData.address}`,
      required: true,
      disabled: true,
      name: "address",
    },
  ];

  const handleChange = (e) => {
    const { name, value } = e.target;
    setUserData((prevData) => {
      const updatedData = { ...prevData, [name]: value };
      console.log(updatedData);
      return updatedData;
    });
  };

  const handleSubmit = async (event) => {
    event.preventDefault();

    const response = await putClinic(lineProfile, userData);
    if (response.error) {
      await Swal.fire({
        title: "系統錯誤",
        text: JSON.stringify(response.data),
        icon: "error",
      });
    } else if (response.data === "not found the user") {
      await Swal.fire({
        title: "帳號不存在",
        text: "請註冊帳號",
        icon: "error",
      });
      //redirection
    } else {
      await Swal.fire({
        title: "修改成功",
        text: "已成功修改成功",
        icon: "success",
      });
    }
  };


  const logoutAlert = async () => {
    const result = await Swal.fire({
      title: "是否登出?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      cancelButtonText: "取消",
      confirmButtonText: "確定",
      
    }) ;
    if (result.isConfirmed) {
      const response = await deleteUser(lineProfile);
      if(response.error) {
        await Swal.fire({
          title: "系統錯誤",
          icon: "error",
        });
      }else{
        await Swal.fire({
          title: "登出成功",
          icon: "success",
          confirmButtonText: "確定",
        }) ;
        navigate("/email");
      }
    }
  } ;

  return (
    <Container
      fluid
      className=" d-flex flex-column backgroundStyle"
      style={{ backgroundImage: `url(${Image})`, width: "100%" }}
    >
      <div className="m-3">
        <Header title="會員資料">
          <img
            src={ImageBack}
            alt="Back"
            style={{ width: "20px", objectFit: "contain" }}
          />
        </Header>
      </div>
      <FormFrame
        formData={formData}
        submitTitle="確認更改"
        handleChange={handleChange}
        redirect="/main"
      />
      <div className=" text-center  memberData-submit w-100"
      onClick={handleSubmit}>
        <Button className="btn-custom-green w-50">儲存會員資料</Button>
      </div>
      <div className="memberData-logout mx-auto text-danger mx-auto mt-4"
        onClick={logoutAlert}>
          登出
      </div>
    </Container>
  );
};

export default MemberData;
